// The synced collections, in push order (WEB_PLAN.md §2.3; the CHECK list of public.sync_items and
// SyncEngine.pushOrder in GroundTeam/Sync/SyncEngine.swift). Parents come before children, so a new record is pushed
// before its `created` activity.

export const SYNC_COLLECTIONS = [
  'settings',
  'users',
  'teams',
  'pipelines',
  'visitResults',
  'customFields',
  'leadSources',
  'templates',
  'badges',
  'territories',
  'records',
  'activities',
  'attachments',
  'routes',
  'autoplays',
  'enrollments',
  'comms',
  'dayLogs',
  'goals',
  'integrations',
  'links',
  'documents',
] as const;

export type Collection = (typeof SYNC_COLLECTIONS)[number];

export const COLLECTION_ORDER: Record<Collection, number> = Object.fromEntries(
  SYNC_COLLECTIONS.map((c, i) => [c, i]),
) as Record<Collection, number>;

export function isCollection(value: unknown): value is Collection {
  return typeof value === 'string' && (SYNC_COLLECTIONS as readonly string[]).includes(value);
}

/** Envelope id of the company `settings` singleton (its payload has no `id` key). */
export const SETTINGS_ID = '00000000-0000-0000-0000-00000000C0DE';

/**
 * Items that hang off a record (SyncEngine.dependentNames): when the server revokes a record from a rep's feed, the
 * rep's local copies of these, when they point at that record and are not the rep's own, go too.
 */
export const RECORD_DEPENDENTS: readonly Collection[] = ['activities', 'comms', 'attachments', 'enrollments'];

/** Collections whose items carry a file in the `company-files` bucket (`file_path`). */
export const FILE_COLLECTIONS: readonly Collection[] = ['attachments', 'documents'];
